import { DATE_FORMAT } from "helpers/common";
import React from "react";

const capitalize = (str) => {
  if (!str) return "--";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const Columns = () => [
  {
    dataField: "line",
    text: "Line Number",
    formatter: (_, row) => <span>{row?.line || "--"}</span>,
  },
  {
    dataField: "coin",
    text: "Coin",
    formatter: (_, row) => (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <img
          src={row?.icon}
          alt={row?.name}
          style={{ width: "28px", height: "28px", borderRadius: "50%" }}
        />
        <div>
          <div style={{ fontWeight: "600" }}>{row?.name || "--"}</div>
          <div style={{ fontSize: "12px", color: "#888" }}>
            {row?.symbol ? row.symbol.toUpperCase() : "--"}
          </div>
        </div>
      </div>
    ),
  },
  {
    dataField: "amount",
    text: "Total Amount",
    formatter: (_, row) => <span>{row?.amount}</span>,
  },
  {
    dataField: "remaining",
    text: "Remaining Amount",
    formatter: (_, row) => <span>{row?.remaining}</span>,
  },
  {
    dataField: "status",
    text: "Status",
    formatter: (_, row) => <span>{capitalize(row?.status)}</span>,
  },
  {
    dataField: "enabledAt",
    text: "Enabled At",
    formatter: (_, row) => (
      <span>{row?.enabledAt ? DATE_FORMAT(row.enabledAt) : "--"}</span>
    ),
  },
];

export default Columns;
